import {MousePosition} from "../model/MousePosition"

const CLICK_THRESHOLD = 4

class CanvasService {
    private mouseDownPos: MousePosition | null = null

    handleMouseDown(position: MousePosition): void {
        this.mouseDownPos = position
    }

    handleMouseUp(position: MousePosition): boolean {
        if (!this.mouseDownPos) {
            return false
        }

        const dx = position.x - this.mouseDownPos.x
        const dy = position.y - this.mouseDownPos.y
        const distance = Math.sqrt(dx * dx + dy * dy)

        this.mouseDownPos = null

        return distance <= CLICK_THRESHOLD
    }

    reset(): void {
        this.mouseDownPos = null
    }
}

export const canvasService = new CanvasService()
